export default actor => ({ form, status }) =>{
    const list = form.casts.value
    list.push(actor)
    return { form, status }
}